import { throwError, of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { map, switchMap, filter } from "rxjs/operators";
import * as queryString from "x-query-string";
import { AppStorage } from "./helpers/AppStorage.js";
import { authHeader } from "./helpers/Auth.js";
import { getDeviceLocationHeaders } from "./helpers/device-location.js";
import { FileSaveHeadersPDF } from "./helpers/http-headers.js";
import { getUnicBrowserCode } from "./ubc-code.js";
const fetchParams = {
  Accept: "application/json",
  "Content-Type": "application/json"
};
const preferencesStorageKey = "customer_preferences";
var CustomHeaders = /* @__PURE__ */ ((CustomHeaders2) => {
  CustomHeaders2["TimeZone"] = "client-timezone";
  CustomHeaders2["UnicBrowserCode"] = "ubc-code";
  CustomHeaders2["WsSessionUuid"] = "ws-session-uuid";
  CustomHeaders2["PWA"] = "PWA";
  return CustomHeaders2;
})(CustomHeaders || {});
const systemTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const setHeaders = (headers) => {
  var _a;
  let secureHeaders = { ...headers, ...getDeviceLocationHeaders() };
  const authHeaderRes = authHeader();
  const timeZone = ((_a = AppStorage.get(preferencesStorageKey)) == null ? void 0 : _a.timezone) || systemTimezone;
  secureHeaders = {
    ...secureHeaders,
    ...authHeaderRes,
    [
      "client-timezone"
      /* TimeZone */
    ]: timeZone
  };
  return secureHeaders;
};
function ajaxPost(url, body, headers, method = "POST") {
  const config = {
    url,
    body,
    headers,
    method,
    withCredentials: true,
    timeout: 0
  };
  return ajax(config);
}
const mapResponse = map((x, index) => x.response);
const ajaxGetJSON = (url, headers, responseType = "json") => {
  const config = {
    headers,
    url,
    method: "GET",
    withCredentials: true,
    responseType,
    timeout: 0
  };
  return mapResponse(
    ajax(config)
  );
};
const getLanguage = () => {
  return window.language || "";
};
const queryTranslateLanguage = "_trlang";
const Fetcher = {
  get: (path, params, entityName, headers) => {
    const queryLanguage = getLanguage();
    let modifiedParams = params ? { ...params } : {};
    if (queryLanguage) {
      modifiedParams = { ...modifiedParams, [queryTranslateLanguage]: queryLanguage };
    }
    const url = Object.keys(modifiedParams).length ? `${path}?${queryString.encode(modifiedParams)}` : `${path}`;
    const httpHeaders = Object.assign({}, headers || fetchParams, {
      "X-Requested-With": "XMLHttpRequest"
    });
    const fileDownloadHeaders = headers && headers.Accept === FileSaveHeadersPDF.Accept;
    getUnicBrowserCode();
    return ajaxGetJSON(
      url,
      setHeaders(httpHeaders),
      !fileDownloadHeaders ? "json" : "blob"
    ).pipe(
      filter((res) => !!res),
      map((res) => toData(res)),
      switchMap((res) => ["error", "fail"].includes(res.status) ? throwError(res) : of(res)),
      map((res) => {
        if (entityName) {
          return res.data[entityName];
        } else if (res.data) {
          return res.data;
        } else {
          return res;
        }
      })
    );
  },
  /**
   *  TEMPORARY DELETE AFTER remove Basic auth
   * @param path
   * @param params
   * @param entityName
   * @param headers
   */
  getBlank: (path, params, entityName, headers) => {
    const queryLanguage = getLanguage();
    const url = params ? `${path}?${queryString.encode(params)}&${queryTranslateLanguage}=${queryLanguage}` : `${path}?${queryTranslateLanguage}=${queryLanguage}`;
    const httpHeaders = Object.assign({}, headers || fetchParams, {
      "X-Requested-With": "XMLHttpRequest"
    });
    return ajaxGetJSON(url, httpHeaders).pipe(
      filter((res) => !!res),
      map((res) => toData(res)),
      switchMap((res) => ["error", "fail"].includes(res.status) ? throwError(res) : of(res)),
      map((res) => {
        if (entityName) {
          return res.data[entityName];
        } else if (res.data) {
          return res.data;
        } else {
          return res;
        }
      })
    );
  },
  post: (path, params, entityName, headers) => {
    const httpHeaders = Object.assign({}, headers || fetchParams, {
      "X-Requested-With": "XMLHttpRequest"
    });
    let body = { ...params };
    if (!!headers && "Content-Type" in headers && headers["Content-Type"] === "application/x-www-form-urlencoded") {
      body = queryString.encode(params);
    }
    getUnicBrowserCode();
    let postUrl = path;
    const queryLanguage = getLanguage();
    if (queryLanguage) {
      postUrl = `${path}?${queryTranslateLanguage}=${queryLanguage}`;
    }
    return ajaxPost(
      postUrl,
      body,
      setHeaders(httpHeaders)
    ).pipe(
      map((res) => res.response),
      map((res) => toData(res)),
      switchMap((res) => ["error", "fail"].includes(res.status) ? throwError(res) : of(res)),
      map((res) => {
        if (entityName) {
          return res.data[entityName];
        } else if (res.data) {
          return res.data;
        } else {
          return res;
        }
      })
    );
  },
  /**
   *  TEMPORARY DELETE AFTER remove Basic authz
   * @param path
   * @param params
   * @param entityName
   * @param headers
   */
  postBlank: (path, params, entityName, headers) => {
    const httpHeaders = Object.assign({}, headers || fetchParams, {
      "X-Requested-With": "XMLHttpRequest"
    });
    let body = { ...params };
    if (!!headers && "Content-Type" in headers && headers["Content-Type"] === "application/x-www-form-urlencoded") {
      body = queryString.encode(params);
    }
    return ajaxPost(path, body, httpHeaders).pipe(
      map((res) => res.response),
      map((res) => toData(res)),
      switchMap((res) => ["error", "fail"].includes(res.status) ? throwError(res) : of(res)),
      map((res) => {
        if (entityName) {
          return res.data[entityName];
        } else if (res.data) {
          return res.data;
        } else {
          return res;
        }
      })
    );
  },
  put: (path, params, entityName, headers) => {
    const httpHeaders = Object.assign({}, headers || fetchParams, {
      "X-Requested-With": "XMLHttpRequest"
    });
    let body = { ...params };
    if (!!headers && "Content-Type" in headers && headers["Content-Type"] === "application/x-www-form-urlencoded") {
      body = queryString.encode(params);
    }
    getUnicBrowserCode();
    return ajaxPost(path, body, setHeaders(httpHeaders), "PUT").pipe(
      map((res) => res.response),
      map((res) => toData(res)),
      switchMap((res) => ["error", "fail"].includes(res.status) ? throwError(res) : of(res)),
      map((res) => {
        if (entityName) {
          return res.data[entityName];
        } else if (res.data) {
          return res.data;
        } else {
          return res;
        }
      })
    );
  },
  patch: (path, params, entityName, headers) => {
    const httpHeaders = Object.assign({}, headers || fetchParams, {
      "X-Requested-With": "XMLHttpRequest"
    });
    let body = { ...params };
    if (!!headers && "Content-Type" in headers && headers["Content-Type"] === "application/x-www-form-urlencoded") {
      body = queryString.encode(params);
    }
    getUnicBrowserCode();
    return ajaxPost(path, body, setHeaders(httpHeaders), "PATCH").pipe(
      map((res) => res.response),
      map((res) => toData(res)),
      switchMap((res) => ["error", "fail"].includes(res.status) ? throwError(res) : of(res)),
      map((res) => {
        if (entityName) {
          return res.data[entityName];
        } else if (res.data) {
          return res.data;
        } else {
          return res;
        }
      })
    );
  },
  delete: (path, params, entityName, headers) => {
    const httpHeaders = Object.assign({}, headers || fetchParams, {
      "X-Requested-With": "XMLHttpRequest"
    });
    let body = { ...params };
    if (!!headers && "Content-Type" in headers && headers["Content-Type"] === "application/x-www-form-urlencoded") {
      body = queryString.encode(params);
    }
    getUnicBrowserCode();
    return ajaxPost(path, body, setHeaders(httpHeaders), "DELETE").pipe(
      map((res) => res.response),
      map((res) => toData(res)),
      switchMap((res) => ["error", "fail"].includes(res.status) ? throwError(res) : of(res)),
      map((res) => {
        if (entityName) {
          return res.data[entityName];
        } else if (res.data) {
          return res.data;
        } else {
          return res;
        }
      })
    );
  },
  external: {
    get: (path, params, entityName, headers) => ajax({
      url: path,
      headers
    }).pipe(
      map((res) => res.response),
      map((res) => toData(res)),
      switchMap((res) => ["error", "fail"].includes(res.status) ? throwError(res) : of(res)),
      map((res) => {
        if (entityName) {
          return res.data[entityName];
        } else if (res.data) {
          return res.data;
        } else {
          return res;
        }
      })
    )
  }
};
function toData(res) {
  if (("message" in res || "messages" in res) && "data" in res) {
    return {
      ...res,
      data: {
        data: res.data,
        messages: res.message ? res.message : res.messages
      }
    };
  }
  if ("data" in res) {
    return res;
  }
  return { data: res, status: res.status };
}
const isAjaxError = (error) => {
  return error.response !== void 0;
};
const isNotAuthError = (error) => {
  return isAjaxError(error) ? error.status === 401 : error.code === 401;
};
const isBlockedUserError = (error) => {
  return (isAjaxError(error) ? error.status === 403 : error.code === 403) && (isAjaxError(error) ? error.response.disabledStatusCode : error.data.disabledStatusCode);
};
export {
  CustomHeaders,
  Fetcher,
  ajaxGetJSON,
  ajaxPost,
  fetchParams,
  isAjaxError,
  isBlockedUserError,
  isNotAuthError,
  preferencesStorageKey,
  setHeaders
};
